import { number, object, oneOfType, string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Icon } from 'components';

const FieldErrorMessage = ({ errors = null, name = '', length = null, min = null, max = null }) => {
  const { t } = useTranslation();
  const error = errors?.[name]?.message || errors?.[name]?.type;
  const errorMessage = error ? t(`form:${error}`) : '';

  if (!errorMessage) return null;

  return (
    <div className="error-message" role="alert">
      <div className="error-icon">
        <Icon name="close" />
      </div>
      {t(`${errorMessage}`, { length, min, max, field: t(`form:${name}`) })}
    </div>
  );
};

FieldErrorMessage.propTypes = {
  errors: object,
  name: string,
  length: oneOfType([string, number]),
  min: number,
  max: number
};

export default FieldErrorMessage;
